import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="priority-loader"
export default class extends Controller {
  static targets = ["frame"]
  static values = {
    maxPriority: { type: Number, default: 10 }
  }

  connect() {
    this.priorityQueues = new Map()
    this.currentPriority = 1
    
    this.initializePriorityQueues()
    this.setupAutoEventListeners()
    this.startLoading()
  }

  initializePriorityQueues() {
    this.frameTargets.forEach(frame => {
      const priority = this.getPriority(frame)
      const src = frame.dataset.src || frame.dataset.prioritySrc || frame.getAttribute('src')
      this.addToQueue(priority, { element: frame, src, loaded: false })
    })
  }

  setupAutoEventListeners() {
    this.frameTargets.forEach(frame => {
      frame.addEventListener('turbo:frame-load', (event) => {
        this.frameLoaded(event)
      })
    })
  }

  addToQueue(priority, data) {
    if (!this.priorityQueues.has(priority)) {
      this.priorityQueues.set(priority, [])
    }
    
    this.priorityQueues.get(priority).push(data)
  }

  getPriority(element) {
    return parseInt(element.dataset.priority || this.maxPriorityValue)
  }

  startLoading() {
    this.processCurrentPriority()
  }

  processCurrentPriority() {
    const queue = this.priorityQueues.get(this.currentPriority)
    
    if (!queue || queue.length === 0) {
      this.moveToNextPriority()
      return
    }

    queue.forEach(frameData => {
      this.loadFrame(frameData)
    })
  }

  loadFrame(frameData) {
    const { element, src } = frameData
    
    if (src && !element.getAttribute('src')) {
      element.setAttribute('src', src)
      
      try {
        if (typeof element.reload === 'function') {
          element.reload()
        }
      } catch (error) {
        console.error(`❌ Error calling reload() on frame:`, error)
      }
    }
  }

  frameLoaded(event) {
    const frame = event.target
    if (!frame) return

    const priority = this.getPriority(frame)
    const queue = this.priorityQueues.get(priority)
    
    if (!queue) return

    const frameData = queue.find(data => data.element === frame)
    if (frameData) {
      frameData.loaded = true
    }

    this.checkPriorityCompletion(priority)
  }

  checkPriorityCompletion(priority) {
    const queue = this.priorityQueues.get(priority)
    if (!queue) return

    const allFramesLoaded = queue.every(data => data.loaded)

    if (allFramesLoaded) {
      this.markPriorityComplete(priority)
    }
  }

  markPriorityComplete(priority) {
    if (priority === this.currentPriority) {
      this.moveToNextPriority()
    }
  }

  moveToNextPriority() {
    this.currentPriority++
    
    if (this.currentPriority <= this.maxPriorityValue) {
      setTimeout(() => {
        this.processCurrentPriority()
      }, 50)
    }
  }
}
